<template>
  <div class="overview block" ref="overview">
    <div class="container-fluid">
      <div class="row">
        <div v-if="$user.administrator || $user.staff">
          <div  class="alert alert-info">
            Welcome back, {{ $user.userData.fullName }}!
          </div>
          <admin-dashboard/>
        </div>
        <template v-else-if="$user.contractor">
          <div>
            <div class="box box-primary">
              <div class="box-header">
                <h1 class="box-title">Contractor Documents</h1>
              </div>
              <div class="box-body">
                <p>
                  <strong>To view the Terms of Engagement and Schedule, please
                    <router-link
                      target="_blank"
                      :to="{ path: '/api/public/pdf/' + $user.userData.ContractorAccount.uuid + '?m=IndividualContractorTOE' }"
                      > click here
                    </router-link>
                    .
                  </strong>
                </p>
                <p v-if="$user.userData.ContractorAccount && !$user.userData.ContractorAccount.termsAgreed">
                  <u><a @click="forceReload()">Click here to view Terms of Engagement and Schedule to proceed.</a></u>
                </p>
              </div>
            </div>
          </div>
        </template>

        <!-- <div v-if="!$user.client">
          <button @click="callDB()">Move PDF file to DBX</button>
        </div> -->
        <div class="background-img full-dim" v-else-if="$user.client">
          <div class="middle">
            <h4 class="top-text">YOU ARE NOW <span class="red">LOGGED IN</span> AND READY TO OBTAIN QUOTES</h4>
            <div class="logo">
              <img src="../../assets/logo-white.svg">
            </div>
            <hr class="logo-line">
            <h4 class="bottom-text">INSURANCE REINSTATEMENT & MAINTENANCE PLANS</h4>
            <span class="buttons-wrapper">
              <button type="button" class="btn custom-button" @click="routeToPath">NEW QUOTE</button>
              <button id="my-quotes-btn" type="button" class="btn custom-button" @click="routeToPath" style="float: right;">MY QUOTES</button>
            </span>
          </div>
        </div>
        <!-- IF REPRESENTATIVE -->
        <div class="background-img full-dim" v-else-if="$user.representative">
          <div class="middle">
            <h4 class="top-text">YOU ARE NOW <span class="red">LOGGED IN</span> AS REPRESENTATIVE</h4>
            <div class="logo">
              <img src="../../assets/logo-white.svg">
            </div>
            <hr class="logo-line">
            <h4 class="bottom-text">INSURANCE REINSTATEMENT & MAINTENANCE PLANS</h4>
            <span class="buttons-wrapper">
              <button type="button" class="btn custom-button" @click="routeToPath">NEW QUOTE</button>
              <button id="my-quotes-btn" type="button" class="btn custom-button" @click="routeToPath" style="float: right;">MY QUOTES</button>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    AGREE_CONTRACTOR_TOE
  } from '@/vuex/types'
  import Api from '@/vuex/api'
  import AdminDashboard from '@/components/admin/AdminDashboard.vue'
  export default {
    name: 'Overview',
    components: {
      AdminDashboard
    },
    methods: {
      async callDB () {
        const api = new Api()
        let response = await api.callDB()
        console.log(response)
      },
      async forceReload () {
        await this.$store.dispatch(AGREE_CONTRACTOR_TOE, this.$user.userData.ContractorAccount.uuid)
      },
      routeToPath (event) {
        if (event.target.innerText === 'NEW QUOTE') {
          this.$router.push('newQuote')
        } else if (event.target.innerText === 'MY QUOTES') {
          this.$router.push('quotes')
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/admin/Overview.vue